import { ReportControllerApi, ReportRequestParameters } from 'src/api/api'
import { BaseApi, configuration } from 'src/api/BaseApi'

export enum ReportType {
    PublisherRevenue = 'PublisherRevenue',
    DspSpent = 'DspSpent',
}

class ReportApi extends BaseApi {
    api: ReportControllerApi

    constructor() {
        super()
        this.api = new ReportControllerApi(configuration, configuration.basePath, this.fetch)
    }

    createReport(params: ReportRequestParameters) {
        return this.api.createReport(params)
    }

    get(id: string, size: number = 50, page: number = 1) {
        return this.api.getReport(id, {query: {page: page, size: size}})
    }

    csv(id: string) {
        return this.api.getCsvReport(id)
    }

    info(id: string) {
        return this.api.reportInfo(id)
    }
}

const reportApi = new ReportApi()
export default reportApi


// WEBPACK FOOTER //
// ./src/component/app/report/ReportApi.ts